import styled from 'styled-components';
import { zIndex } from '../../../tokens';

interface ResizablePanelProps {
	resizeOnSide: 'left' | 'right' | 'top' | 'bottom' | 'none';
}

export const Base = styled.div<ResizablePanelProps>`
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: ${({ theme }) => theme.gray[0]};
	min-height: 0;
	height: ${({ resizeOnSide }) =>
		resizeOnSide === 'left' || resizeOnSide === 'right' || resizeOnSide === 'none'
			? '100%'
			: 'auto'};
	width: ${({ resizeOnSide }) =>
		resizeOnSide === 'top' || resizeOnSide === 'bottom' ? '100%' : 'auto'};
	max-height: ${({ resizeOnSide }) =>
		resizeOnSide === 'left' || resizeOnSide === 'right' || resizeOnSide === 'none'
			? '100%'
			: 'none'};
`;

export const Handle = styled.div<ResizablePanelProps>`
	position: absolute;
	z-index: ${zIndex.panelOverlay};
	width: ${({ resizeOnSide }) =>
		resizeOnSide === 'left' || resizeOnSide === 'right' ? '4px' : 'auto'};
	height: ${({ resizeOnSide }) =>
		resizeOnSide === 'top' || resizeOnSide === 'bottom' ? '4px' : 'auto'};
	${({ resizeOnSide }) =>
		resizeOnSide === 'top' || resizeOnSide === 'bottom' ? 'right: 0;' : 'bottom: 0;'};
	${({ resizeOnSide }) =>
		resizeOnSide === 'top' || resizeOnSide === 'bottom' ? 'left: 0;' : 'top: 0;'};
	${(p) => p.resizeOnSide}: -2px;
	margin-${(p) => p.resizeOnSide}: 2px;
	border-${(p) => p.resizeOnSide}: 1px solid ${({ theme }) => theme.gray['200']};
	cursor: ${({ resizeOnSide }) =>
		resizeOnSide === 'left' || resizeOnSide === 'right' ? 'col-resize' : 'row-resize'};
`;
